import * as EnglishUS from '../../../messages/en-US';
import type { IMessages } from '../../../messages/MessageKeys';

const languageCode = EnglishUS.languageCode;
const messages: IMessages = {
	...EnglishUS.messages,
	containers: {
		...EnglishUS.messages.containers,
		reports: {
			...EnglishUS.messages.containers.reports,
			reportTable: {
				...EnglishUS.messages.containers.reports.reportTable,
				reportNames: {
					...EnglishUS.messages.containers.reports.reportTable.reportNames,
					discontinuedItems: 'On-Order Guide Discontinued Item Alerts',
				},
			},
		},
		home: {
			...EnglishUS.messages.containers.home,
			allLocations: 'All Locations',
			blueprintCard: {
				...EnglishUS.messages.containers.home.blueprintCard,
				locations:
					'{count, number} {count, plural, one {Location} other {Locations}}',
			},
			deleteMogWarning:
				'You cannot undo this action. Deleting this master order guide will also delete {metaProductCount} master items from {locationCount} locations.',
		},
		metaProductListing: {
			...EnglishUS.messages.containers.metaProductListing,
			remote: 'Central Warehouse',
		},
		singleSignOn: {
			sessionExpired:
				'Your session has timed out due to inactivity. For security purposes, please reconnect via your link in DSSI Manage.',
		},
	},
};

messages.containers.metaProductWorkflow.rulesets.leadTimeSDR =
	'Stocked, Demand, then Central';
messages.containers.metaProductWorkflow.rulesets.prioritySDR =
	'Highest Priority';
messages.containers.metaProductWorkflow.remote = 'Central';
messages.containers.metaProductWorkflow.selectionTab = 'Select Products';
messages.containers.metaProductWorkflow.coverageTab =
	'Distribution Centers & Coverage';

export { messages, languageCode };
